import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import ComboBox from '../../../../Components/ComboBox'
import CustomButton from '../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../utils/api'
import { currentDate } from '../../../../utils/helpers'
import urls from '../../../../utils/urls'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import AddIcon from '@mui/icons-material/Add'
import CreateCarModel from './CreateCarModel'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function CreateOperationForm({
  setOperations,
  vehiculesTypes,
  carLogoType,
  fetchCarPicModel,
}) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  let w_vehicule = localStorage.getItem('w-vehicule')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [moterType, setMotortype] = useState([])
  const [boatType, setBoatType] = useState([])
  const [carType, setCarType] = useState([])
  const [carLogoTypes, setCarLogoTypes] = useState([])
  const [carMarque, setCarMarque] = useState([])
  const [selectedVehicle, setSelectedVehicle] = useState('')
  const [selectedModel, setSelectedModel] = useState(null)
  const [selectedMarque, setSelectedMarque] = useState(null)
  const [selectedVehicleType, setSelectedVehicleType] = useState(null)
  const [addModel, setAddModel] = useState(false)

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      vehicleType: '',
      Marque: '',
      Model: '',
      Motortype: '',
      Conso: '',
      Contact: '',
      DatePurch: currentDate(),
      Identification: '',
      boatType: '',
      Vhpower: '',
      emission: '',
    },
  })

  useEffect(() => {
    if (w_vehicule) {
      handleClickOpen()
    }
    // fetchMotorTypes();
    // fetchBoatTypes();
  }, [])
  useEffect(() => {
    if (selectedMarque) {
      let tt = []
      carLogoType.forEach((e) => {
        if (e.Marques.Marque === selectedMarque.label)
          tt.push({ label: e.Name, id: e.id, mid: e.Marques.id })
      })
      setCarType(tt)
    }
    if (selectedVehicleType) {
      setVehicleMarque(selectedVehicleType.id)
    }
  }, [carLogoType])

  const handleClickOpen = () => {
    setOpen(true)
    // fetchCarPicModel()
    fetchCarLogoModel()
    fetchMotorTypes()
    fetchBoatTypes()
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelectedVehicleType(null)
    setSelectedModel(null)
    setSelectedMarque(null)
  }
  const setVehicleMarque = (id) => {
    const carLogoTypes = []
    const typesCheck = []
    carLogoType.forEach((v) => {
      if (v.vehicletype === id) {
        if (!typesCheck.includes(v.Marques.Marque)) {
          typesCheck.push(v.Marques.Marque)
          carLogoTypes.push({ label: `${v.Marques.Marque}`, id: v.Marques.id })
        }
      }
    })

    setCarMarque(carLogoTypes.sort((a, b) => a.label.localeCompare(b.label)))
  }

  const onSubmit = async (data) => {
    if (data.vehicleType === null) {
      alert('Please Select Type de véhicule.')
    } else {
      const payload = {
        ...data,
        vehicleType: data.vehicleType.id,
        Motortype: data.Motortype.id,
        Model: data.Model.id,
        Marque: data.Model.mid,
      }
      if (data.boatType !== '' && payload.boatType !== null) {
        payload.boatType = data.boatType.id
      }
      if (data.Conso === '') {
        payload.Conso = 0
      }
      if (data.Vhpower === '') {
        payload.Vhpower = 0
      }
      if (data.emission === '') {
        payload.emission = 0
      }
      const response = await makePostRequest(urls.crudVehiclesOperations, payload, {}, true)
      if (response.status === 201) {
        setOperations((operations) => ({
          ...operations,
          results: [...operations.results, response.data],
          count: operations.count + 1,
        }))
        handleClose()
        if (w_vehicule) {
          let pr_count = localStorage.getItem('wv_count')
          if (pr_count) {
            localStorage.setItem('wv_count', parseInt(pr_count) + 1)
            localStorage.setItem(
              't_message',
              `Vous avez ajouté ${parseInt(pr_count) + 1} véhicules.`,
            )
          } else {
            localStorage.setItem('wv_count', 1)
            localStorage.setItem('t_message', 'Vous avez ajouté 1 véhicule.')
          }
          localStorage.setItem('wv_done', true)
          navigate('/')
        }
      }
    }
  }

  const fetchMotorTypes = async () => {
    const url = urls.fetchMotorTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.motor_type}`, id: v.id })
      })
      setMotortype([...filterTypes])
    }
  }
  const fetchBoatTypes = async () => {
    const url = urls.fetchBoatTypes + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.boat_type}`, id: v.id })
      })
      setBoatType([...filterTypes])
    }
  }

  const fetchCarLogoModel = async () => {
    const url = urls.fetchCarLogoModel
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Marque}`, id: v.id })
      })
      setCarLogoTypes(filterTypes)
      // setCarLogoType([...filterTypes])
    }
  }
  const fetchCarModel = async () => {
    // if (selectedMarque) {
    //   let tt = []
    //   carLogoType.forEach((e) => {
    //     if (e.Marques.Marque === selectedMarque.label)
    //       tt.push({ label: e.Name, id: e.id, mid: e.Marques.id })
    //   })
    //   setCarType(tt)
    // }
  }
  return (
    <Box>
      {addModel && (
        <CreateCarModel
          vehiculesTypes={vehiculesTypes}
          fetchCarModel={fetchCarModel}
          setAddModel={setAddModel}
          fetchCarPicModel={fetchCarPicModel}
          carLogoTypes={carLogoTypes}
          selectedVehicleTypes={selectedVehicleType}
          selectedMarques={selectedMarque}
        />
      )}
      {isMobile ? (
        <AddCircleIcon sx={{ color: 'white' }} onClick={handleClickOpen} />
      ) : (
        // LAP-733 (GE022)
        <CustomButton onClick={handleClickOpen}>{t('vehicles.btnCreate')}</CustomButton>
      )}
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>Ajout véhicules</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setSelectedVehicleType(j)
                if (j) {
                  setVehicleMarque(j.id)
                  setSelectedVehicle(j.label)
                } else {
                  setSelectedVehicle('')
                  setVehicleMarque(-1)
                }
                setValue('vehicleType', j)
                setSelectedMarque(null)
                setSelectedModel(null)
              }}
              label="Type de véhicule"
              data={vehiculesTypes}
              name="vehicleType"
              required={true}
              selectedValue={selectedVehicleType}
            />

            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Marque', j)
                setSelectedModel(null)
                setValue('Model', '')
                setSelectedMarque(j)
                let tt = []
                carLogoType.forEach((e) => {
                  if (e.Marques.Marque === j.label)
                    tt.push({ label: e.Name, id: e.id, mid: e.Marques.id })
                })
                setCarType(tt)
              }}
              label="Marque"
              data={carMarque}
              name="Marque"
              required={true}
              selectedValue={selectedMarque}
            />
            {/* <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Model', j)
                setSelectedModel(j)
              }}
              label="Modèle"
              data={carType}
              name="Model"
              required={true}
              selectedValue={selectedModel}
            /> */}
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              <Box sx={{ width: '100%' }}>
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setValue('Model', j)
                    setSelectedModel(j)
                  }}
                  label="Modèle"
                  data={carType}
                  name="Model"
                  required={true}
                  selectedValue={selectedModel}
                />
              </Box>
              <Box
                sx={{
                  width: '30px',
                  marginTop: '12px',
                  display: 'flex',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  paddingX: '5px',
                }}
                onClick={() => setAddModel(true)}
              >
                <AddIcon />
              </Box>
            </Box>

            <ComboBox
              handleAutoComplete={(e, j) => setValue('Motortype', j)}
              label="Type de moteur"
              data={moterType}
              name="Motortype"
              required={true}
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Contact"
              label="Conducteur"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="DatePurch"
              label="Date d’acquisition"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name="Identification"
              label="Immatriculation"
            />
            {selectedVehicle === 'Nautisme' ? (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('boatType', j)}
                label="Type de bateau"
                data={boatType}
                name="boatType"
              />
            ) : (
              ''
            )}

            {/* <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name='Vhpower'
              label='Puissance fiscal (cv)'
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: false,
                size: 'small',
              }}
              rules={{ required: false }}
              name='emission'
              label='Emission (g/co2)'
            /> */}
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button
              onClick={() => {
                handleClose()
                if (w_vehicule) {
                  navigate('/')
                }
              }}
            >
              Annuler
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  )
}
